import React, { useState, useEffect, useCallback } from 'react';
import {
  getProdutos, createProduto, updateProduto, deleteProduto, getMovimentacoes,
  addEntrada, addSaida, isAuthenticated, logout, getUsuario, getResumo,
  getClientes, createCliente, deleteCliente,
  criarPedido,
  getInsumos, getReceitas,
} from './api';
import LoginPage from './components/LoginPage';
import ProdutoForm from './components/ProdutoForm';
import TabelaProdutos from './components/TabelaProdutos';
import MovimentacaoModal from './components/MovimentacaoModal';
import Historico from './components/Historico';
import ClienteForm from './components/ClienteForm';
import TabelaClientes from './components/TabelaClientes';
import Toast from './components/Toast';
import ConfirmModal from './components/ConfirmModal';
import SearchableSelect from './components/SearchableSelect';
import ReceitaModal from './components/ReceitaModal';
import InsumosPage from './components/InsumosPage';
import ReceitasPage from './components/ReceitasPage';
import FinanceiroPage from './components/FinanceiroPage';
import TutorialPage from './components/TutorialPage';

const NAV = [
  { key: 'inicio',     icon: '🏠', label: 'Início' },
  { key: 'vender',     icon: '🛒', label: 'Vender' },
  { key: 'estoque',    icon: '📦', label: 'Estoque' },
  { key: 'receitas',   icon: '📝', label: 'Receitas' },
  { key: 'financeiro', icon: '💰', label: 'Financeiro' },
  { key: 'tutorial',   icon: '📚', label: 'Ajuda' },
];

const MESES = ['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez'];
const fmt = (v) => Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 });

/* ─── Página de Venda ─── */
function VenderPage({ produtos, clientes, preSelected, onCreateCliente, onVenda, saving }) {
  const [cart, setCart] = useState([]);
  const [clienteId, setClienteId] = useState('');
  const [erro, setErro] = useState('');
  const [novoCliente, setNovoCliente] = useState('');
  const [showAddCliente, setShowAddCliente] = useState(false);

  useEffect(() => {
    if (preSelected && !cart.find(i => i.id === Number(preSelected))) {
      const p = produtos.find(x => x.id === Number(preSelected));
      if (p && p.quantidade > 0) setCart([{ id: p.id, nome: p.nome, preco: Number(p.preco), qtd: 1, max: p.quantidade }]);
    }
  }, [preSelected]);

  const addToCart = (p) => {
    if (p.quantidade <= 0) return;
    setErro('');
    const idx = cart.findIndex(i => i.id === p.id);
    if (idx >= 0) {
      if (cart[idx].qtd >= p.quantidade) { setErro(`Estoque máximo: ${p.quantidade}`); return; }
      const n = [...cart]; n[idx] = { ...n[idx], qtd: n[idx].qtd + 1 }; setCart(n);
    } else {
      setCart([...cart, { id: p.id, nome: p.nome, preco: Number(p.preco), qtd: 1, max: p.quantidade }]);
    }
  };

  const setItemQtd = (id, qtd) => {
    const item = cart.find(i => i.id === id);
    if (!item) return;
    const q = Math.max(0, Math.min(qtd, item.max));
    if (q === 0) setCart(cart.filter(i => i.id !== id));
    else setCart(cart.map(i => i.id === id ? { ...i, qtd: q } : i));
  };

  const total = cart.reduce((s, i) => s + i.preco * i.qtd, 0);
  const totalItens = cart.reduce((s, i) => s + i.qtd, 0);

  const handleAddCliente = (e) => {
    e.preventDefault();
    if (!novoCliente.trim()) return;
    onCreateCliente({ nome: novoCliente.trim() });
    setNovoCliente(''); setShowAddCliente(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault(); setErro('');
    if (cart.length === 0) { setErro('Adicione produtos ao pedido'); return; }
    onVenda({ cliente_id: clienteId ? Number(clienteId) : undefined, itens: cart.map(i => ({ produto_id: i.id, quantidade: i.qtd })) });
  };

  return (
    <form onSubmit={handleSubmit}>
      {erro && <div className="err">{erro}</div>}

      <span className="lbl">Produtos</span>
      {produtos.length === 0 ? (
        <div className="mt"><span className="mt-ico">📦</span>Nenhum produto cadastrado.</div>
      ) : (
        <div className="p-grid">
          {produtos.map(p => {
            const inCart = cart.find(i => i.id === p.id);
            const sem = p.quantidade <= 0;
            return (
              <div key={p.id} className={`p-chip ${inCart ? 'sel' : ''} ${sem ? 'dim' : ''}`}
                onClick={() => !sem && addToCart(p)}>
                <strong style={{ fontSize: 13 }}>{p.nome}</strong>
                <p>R$ {Number(p.preco).toFixed(2)} · {p.quantidade} un.</p>
                {inCart && <span className="bd bd-g" style={{ marginTop: 4, display: 'inline-block' }}>{inCart.qtd}x</span>}
              </div>
            );
          })}
        </div>
      )}

      {cart.length > 0 && (
        <>
          <span className="lbl">Carrinho</span>
          <div className="lst mb2">
            {cart.map(item => (
              <div key={item.id} className="it">
                <div className="it-main">
                  <strong style={{ fontSize: 13 }}>{item.nome}</strong>
                  <div style={{ fontSize: 12, color: 'var(--c4)' }}>R$ {item.preco.toFixed(2)} un.</div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 4, flexShrink: 0 }}>
                  <button type="button" className="btn btn3 btn-sm" style={{ width: 30, padding: 4 }}
                    onClick={() => setItemQtd(item.id, item.qtd - 1)}>−</button>
                  <span style={{ fontWeight: 700, minWidth: 24, textAlign: 'center', fontSize: 13 }}>{item.qtd}</span>
                  <button type="button" className="btn btn3 btn-sm" style={{ width: 30, padding: 4 }}
                    onClick={() => setItemQtd(item.id, item.qtd + 1)} disabled={item.qtd >= item.max}>+</button>
                  <span style={{ fontWeight: 700, fontSize: 13, marginLeft: 6, color: 'var(--g)', minWidth: 52, textAlign: 'right', flexShrink: 0 }}>
                    R$ {(item.preco * item.qtd).toFixed(2)}
                  </span>
                </div>
              </div>
            ))}
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12, padding: '10px 14px', background: 'var(--g4)', borderRadius: 12, border: '1px solid var(--g3)' }}>
            <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--g2)' }}>{totalItens} un. · {cart.length} produto(s)</span>
            <strong style={{ fontSize: 18, color: 'var(--g)' }}>R$ {total.toFixed(2)}</strong>
          </div>
        </>
      )}

      <span className="lbl">Cliente (opcional)</span>
      {clientes.length === 0 && !showAddCliente ? (
        <button type="button" className="btn btn3 btn-sm" onClick={() => setShowAddCliente(true)} style={{ alignSelf: 'flex-start', marginBottom: 12 }}>
          + Cadastrar cliente
        </button>
      ) : showAddCliente ? (
        <div className="inp-r" style={{ marginBottom: 12 }}>
          <input className="inp" placeholder="Nome do cliente" value={novoCliente} onChange={e => setNovoCliente(e.target.value)} autoFocus />
          <button type="button" className="btn btn1 btn-sm" onClick={handleAddCliente}>OK</button>
          <button type="button" className="btn btn3 btn-sm" onClick={() => { setShowAddCliente(false); setNovoCliente(''); }}>✕</button>
        </div>
      ) : (
        <div style={{ marginBottom: 12 }}>
          <SearchableSelect
            value={clienteId}
            placeholder="Sem cliente"
            options={clientes.map(c => ({ value: String(c.id), label: c.nome, sub: `${c.total_pedidos} ped.` }))}
            onChange={setClienteId}
            onAddNew={() => setShowAddCliente(true)}
          />
        </div>
      )}

      <button className="btn btn1 btn-lg" type="submit" disabled={cart.length === 0 || saving}>
        {saving ? 'Salvando...' : `✅ Finalizar Pedido · R$ ${total.toFixed(2)}`}
      </button>
    </form>
  );
}

/* ─── Aba Estoque: Produtos + Histórico ─── */
function EstoquePage({ produtos, movimentacoes, saving, showForm, setShowForm, onCreateProduto, onEditProduto, onDeleteProduto, onEntrada, onVender, onReceita }) {
  const [subTab, setSubTab] = useState('produtos');

  return (
    <div>
      <div className="sub-tabs" style={{ marginBottom: 16 }}>
        <button className={subTab === 'produtos' ? 'on' : ''} onClick={() => setSubTab('produtos')}>📦 Produtos</button>
        <button className={subTab === 'historico' ? 'on' : ''} onClick={() => setSubTab('historico')}>📋 Histórico</button>
      </div>

      {subTab === 'produtos' && (
        <div className="c">
          <div className="c-h">
            <span className="c-t">Produtos</span>
            <button className="btn btn1 btn-sm" onClick={() => setShowForm(!showForm)} disabled={saving}>
              {showForm ? 'Fechar' : '+ Novo produto'}
            </button>
          </div>
          {showForm && (
            <div className="mb2">
              <ProdutoForm
                onSubmit={async (data) => { await onCreateProduto(data); setShowForm(false); }}
                onCancel={() => setShowForm(false)}
              />
            </div>
          )}
          <TabelaProdutos
            produtos={produtos}
            onEntrada={onEntrada}
            onSaida={onVender}
            onEdit={onEditProduto}
            onDelete={onDeleteProduto}
            onReceita={onReceita}
          />
        </div>
      )}

      {subTab === 'historico' && (
        <div className="c">
          <span className="c-t">Histórico de movimentações</span>
          <div style={{ marginTop: 12 }}><Historico movimentacoes={movimentacoes} /></div>
        </div>
      )}
    </div>
  );
}

/* ─── App Principal ─── */
export default function App() {
  const [autenticado, setAutenticado] = useState(isAuthenticated());
  const [usuario, setUsuario] = useState(getUsuario());
  const [produtos, setProdutos] = useState([]);
  const [movimentacoes, setMovimentacoes] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [resumo, setResumo] = useState(null);
  const [insumos, setInsumos] = useState([]);
  const [receitas, setReceitas] = useState([]);
  const [receitaModal, setReceitaModal] = useState(null);
  const [receitaTarget, setReceitaTarget] = useState(null); // { receitaId, produtoId }
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [tab, setTab] = useState('inicio');
  const [showForm, setShowForm] = useState(false);
  const [showClienteForm, setShowClienteForm] = useState(false);
  const [movModal, setMovModal] = useState(null);
  const [preSelected, setPreSelected] = useState('');
  const [toast, setToast] = useState(null);
  const [confirm, setConfirm] = useState(null);
  const [editProduto, setEditProduto] = useState(null);

  const showToast = (msg, type = 'success') => setToast({ message: msg, type });
  const askConfirm = (title, message) => new Promise(resolve => {
    setConfirm({ title, message, onConfirm: () => { setConfirm(null); resolve(true); }, onCancel: () => { setConfirm(null); resolve(false); } });
  });

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const hoje = new Date();
      const [p, m, r, cl, ins, rec] = await Promise.all([
        getProdutos(), getMovimentacoes(),
        getResumo(hoje.getMonth() + 1, hoje.getFullYear()),
        getClientes(),
        getInsumos(), getReceitas(),
      ]);
      setProdutos(p); setMovimentacoes(m); setResumo(r); setClientes(cl);
      setInsumos(ins); setReceitas(rec);
    } catch (err) { if (err.message.includes('401') || err.message.includes('Token')) handleLogout(); }
    setLoading(false);
  }, []);

  useEffect(() => { if (autenticado) loadData(); }, [autenticado, loadData]);

  const handleLogin = (user) => { setUsuario(user); setAutenticado(true); };
  const handleLogout = () => { logout(); setAutenticado(false); setUsuario(null); };

  const doSave = async (fn, okMsg) => {
    setSaving(true);
    try { await fn(); showToast(okMsg); loadData(); }
    catch (err) { showToast(err.message, 'error'); }
    setSaving(false);
  };

  const switchTab = (key) => {
    setTab(key);
    setShowForm(false); setShowClienteForm(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const lowStock = produtos.filter(p => p.quantidade > 0 && p.quantidade <= 3).length;
  const vendasRecentes = movimentacoes.filter(m => m.tipo === 'saida').slice(0, 6);

  if (!autenticado) return <LoginPage onLogin={handleLogin} />;

  if (loading) return (
    <div className="layout">
      <aside className="sidebar">
        <div className="sb-brand"><span className="sb-logo">🥗</span><div><div className="sb-app-name">Marmitas Fit</div></div></div>
        <div style={{ flex: 1 }} />
      </aside>
      <div className="main">
        <div className="hdr"><div><h1>🥗 Marmitas Fit</h1></div></div>
        <div className="pg" style={{ paddingTop: 24 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 12 }}>
            {[1,2,3,4].map(i => <div key={i} className="sk-sm" />)}
          </div>
          <div className="sk">{[1,2,3,4].map(i => <div key={i} className="sk-it" />)}</div>
        </div>
      </div>
    </div>
  );

  const mesLabel = MESES[(resumo?.mes || 1) - 1];

  /* ── Nav helper ── */
  const NavButtons = ({ className }) => NAV.map(n => (
    <button key={n.key} className={tab === n.key ? 'on' : ''} onClick={() => switchTab(n.key)}>
      <span className={className === 'sb-nav' ? 'sb-nav-ico' : ''}>
        {n.icon}
        {n.key === 'estoque' && lowStock > 0 && className === 'sb-nav'
          ? <span className="sb-badge">{lowStock}</span>
          : n.key === 'estoque' && lowStock > 0 && className !== 'sb-nav'
            ? <span className="nav-dot">{lowStock}</span>
            : null}
      </span>
      {n.label}
    </button>
  ));

  const pageTitle = NAV.find(n => n.key === tab)?.label || '';

  return (
    <div className="layout">
      {/* ══ SIDEBAR (desktop) ══ */}
      <aside className="sidebar">
        <div className="sb-brand">
          <span className="sb-logo">🥗</span>
          <div>
            <div className="sb-app-name">Marmitas Fit</div>
            <div className="sb-greeting">Olá, {usuario?.nome}</div>
          </div>
        </div>

        {resumo && (
          <div className="sb-stats">
            <div className="sb-stats-title">📅 {mesLabel} / {resumo.ano}</div>
            <div className="sb-stat"><span>💰 Receita</span><strong>{fmt(resumo.receita_vendas)}</strong></div>
            <div className="sb-stat"><span>📈 Lucro</span><strong style={{ color: resumo.lucro >= 0 ? '#86efac' : '#fca5a5' }}>{fmt(resumo.lucro)}</strong></div>
            <div className="sb-stat"><span>📦 Estoque</span><strong>{resumo.total_unidades} un.</strong></div>
            {lowStock > 0 && <div className="sb-stat"><span>⚠️ Críticos</span><strong style={{ color: '#fca5a5' }}>{lowStock} item(s)</strong></div>}
          </div>
        )}

        <nav className="sb-nav">
          <div className="sb-nav-lbl">Menu</div>
          <NavButtons className="sb-nav" />
        </nav>

        <div className="sb-footer">
          <button className="sb-logout" onClick={handleLogout}>↩ Sair da conta</button>
        </div>
      </aside>

      {/* ══ MAIN ══ */}
      <div className="main">
        <div className="hdr">
          <div><h1>🥗 Marmitas Fit</h1><div className="hdr-user">Olá, {usuario?.nome}</div></div>
          <button className="hdr-btn" onClick={handleLogout}>Sair</button>
        </div>

        <div className="page-hdr">
          <h2>{pageTitle}</h2>
          {resumo && <span>📅 {mesLabel} / {resumo.ano}</span>}
        </div>

        <div className="pg" key={tab}>

          {/* ── INÍCIO ── */}
          {tab === 'inicio' && (
            <>
              {resumo && (
                <div className="kpi-row">
                  <div className="kpi-card kc-g">
                    <div className="kpi-ico">💰</div>
                    <div className="kpi-lbl">Receita de {mesLabel}</div>
                    <div className="kpi-val">{fmt(resumo.receita_vendas)}</div>
                  </div>
                  <div className={`kpi-card ${resumo.lucro >= 0 ? 'kc-b' : 'kc-r'}`}>
                    <div className="kpi-ico">{resumo.lucro >= 0 ? '📈' : '📉'}</div>
                    <div className="kpi-lbl">Lucro</div>
                    <div className="kpi-val">{fmt(resumo.lucro)}</div>
                    {resumo.receita_vendas > 0 && (
                      <div className="kpi-sub">{((resumo.lucro / resumo.receita_vendas) * 100).toFixed(0)}% de margem</div>
                    )}
                  </div>
                  <div className={`kpi-card ${resumo.custo_insumos + resumo.custos_operacionais > 0 ? 'kc-y' : 'kc-g'}`}>
                    <div className="kpi-ico">🧾</div>
                    <div className="kpi-lbl">Custos</div>
                    <div className="kpi-val">{fmt(resumo.custo_insumos + resumo.custos_operacionais)}</div>
                  </div>
                  <div className={`kpi-card ${lowStock > 0 ? 'kc-r' : 'kc-g'}`}>
                    <div className="kpi-ico">📦</div>
                    <div className="kpi-lbl">Estoque</div>
                    <div className="kpi-val">{resumo.total_unidades}<small style={{ fontSize: 14, fontWeight: 600 }}> un.</small></div>
                    {lowStock > 0 && <div className="kpi-sub">⚠️ {lowStock} item(s) crítico(s)</div>}
                  </div>
                </div>
              )}

              <div className="dash-grid">
                {vendasRecentes.length > 0 && (
                  <div className="c">
                    <div className="c-h">
                      <span className="c-t">Últimas Vendas</span>
                      <button className="btn btn3 btn-sm" onClick={() => switchTab('financeiro')}>Ver financeiro</button>
                    </div>
                    <div className="lst">
                      {vendasRecentes.map(m => (
                        <div key={m.id} className="it">
                          <div className="it-main">
                            <strong style={{ fontSize: 13 }}>{m.produto_nome}</strong>
                            {m.cliente_nome && <div style={{ fontSize: 11, color: 'var(--c4)', marginTop: 1 }}>👤 {m.cliente_nome}</div>}
                          </div>
                          <div style={{ textAlign: 'right', flexShrink: 0 }}>
                            <div style={{ fontSize: 11, color: 'var(--c4)' }}>{new Date(m.data).toLocaleDateString('pt-BR')}</div>
                            <div style={{ fontWeight: 800, color: 'var(--g)', fontSize: 14 }}>R$ {(m.quantidade * m.preco_unitario).toFixed(2)}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                <div className="c">
                  <div className="c-h">
                    <span className="c-t">Estoque</span>
                    <button className="btn btn3 btn-sm" onClick={() => switchTab('estoque')}>Gerenciar</button>
                  </div>
                  {produtos.length === 0 ? (
                    <div className="mt" style={{ padding: '16px 0' }}><span className="mt-ico">📦</span>Nenhum produto.</div>
                  ) : (
                    <div className="lst">
                      {produtos.slice(0, 6).map(p => (
                        <div key={p.id} className="it"
                          onClick={() => { if (p.quantidade > 0) { setPreSelected(String(p.id)); switchTab('vender'); } }}
                          style={{ cursor: p.quantidade > 0 ? 'pointer' : 'default' }}>
                          <div className="it-main">
                            <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
                              <strong style={{ fontSize: 13 }}>{p.nome}</strong>
                              <span className={`bd ${p.quantidade === 0 ? 'bd-y' : p.quantidade <= 3 ? 'bd-r' : 'bd-g'}`}>
                                {p.quantidade === 0 ? 'Sem estoque' : `${p.quantidade} un.`}
                              </span>
                            </div>
                          </div>
                          {p.quantidade > 0 && <span style={{ fontSize: 20, color: 'var(--c3)', flexShrink: 0 }}>›</span>}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              <div className="c">
                <div className="c-t" style={{ marginBottom: 14 }}>Ações Rápidas</div>
                <div className="qa-grid">
                  <button className="qa-btn qa-primary" onClick={() => switchTab('vender')}>
                    <span className="qa-ico">🛒</span>Nova Venda
                  </button>
                  <button className="qa-btn" onClick={() => switchTab('estoque')}>
                    <span className="qa-ico">📦</span>Estoque
                  </button>
                  <button className="qa-btn" onClick={() => switchTab('receitas')}>
                    <span className="qa-ico">📝</span>Receitas
                  </button>
                  <button className="qa-btn" onClick={() => switchTab('financeiro')}>
                    <span className="qa-ico">💰</span>Financeiro
                  </button>
                </div>
              </div>
            </>
          )}

          {/* ── VENDER ── */}
          {tab === 'vender' && (
            <div className="c">
              <div className="c-h"><span className="c-t">Nova Venda</span></div>
              <VenderPage
                produtos={produtos} clientes={clientes} preSelected={preSelected} saving={saving}
                onCreateCliente={async (data) => {
                  const c = await createCliente(data);
                  setClientes(prev => [...prev, { ...c, total_pedidos: 0 }]);
                  showToast('Cliente cadastrado!');
                }}
                onVenda={async (payload) => {
                  await doSave(async () => {
                    await criarPedido(payload);
                    setPreSelected(''); switchTab('inicio');
                  }, `Pedido finalizado! ${payload.itens.length} produto(s)`);
                }}
              />
            </div>
          )}

          {/* ── ESTOQUE (Produtos + Insumos + Histórico) ── */}
          {tab === 'estoque' && (
            <EstoquePage
              produtos={produtos}
              movimentacoes={movimentacoes}
              saving={saving}
              showForm={showForm}
              setShowForm={setShowForm}
              onCreateProduto={data => doSave(() => createProduto(data), 'Produto cadastrado!')}
              onEditProduto={p => setEditProduto(p)}
              onDeleteProduto={async p => {
                if (await askConfirm('Remover produto', `Excluir "${p.nome}"? Esta ação não pode ser desfeita.`))
                  await doSave(() => deleteProduto(p.id), 'Produto removido');
              }}
              onEntrada={p => setMovModal({ produto: p, tipo: 'entrada' })}
              onVender={p => { setPreSelected(String(p.id)); switchTab('vender'); }}
              onReceita={p => {
                setReceitaTarget({ receitaId: p.receita_id || null, produtoId: p.id });
                switchTab('receitas');
              }}
            />
          )}

          {/* ── RECEITAS ── */}
          {tab === 'receitas' && (
            <ReceitasPage
              insumos={insumos}
              receitas={receitas}
              produtos={produtos}
              onToast={showToast}
              onReload={loadData}
              initialTarget={receitaTarget}
              onTargetConsumed={() => setReceitaTarget(null)}
            />
          )}

          {/* ── FINANCEIRO (Mês + Gastos + Contas Fixas + Precificação + Relatórios) ── */}
          {tab === 'financeiro' && (
            <FinanceiroPage onToast={showToast} />
          )}

          {/* ── TUTORIAL ── */}
          {tab === 'tutorial' && <TutorialPage />}

          {/* ── CLIENTES (ainda acessível via link interno se necessário) ── */}
          {tab === 'clientes' && (
            <div className="c">
              <div className="c-h">
                <span className="c-t">Clientes</span>
                <button className="btn btn1 btn-sm" onClick={() => setShowClienteForm(!showClienteForm)} disabled={saving}>
                  {showClienteForm ? 'Fechar' : '+ Novo'}
                </button>
              </div>
              {showClienteForm && (
                <div className="mb2">
                  <ClienteForm
                    onSubmit={async (data) => { await doSave(() => createCliente(data), 'Cliente cadastrado!'); setShowClienteForm(false); }}
                    onCancel={() => setShowClienteForm(false)}
                  />
                </div>
              )}
              <TabelaClientes clientes={clientes}
                onDelete={async (c) => {
                  if (await askConfirm('Remover cliente', `Excluir "${c.nome}"?`))
                    await doSave(() => deleteCliente(c.id), 'Cliente removido');
                }}
              />
            </div>
          )}

        </div>{/* end .pg */}

        {/* Mobile bottom nav */}
        <nav className="nav">
          {NAV.map(n => (
            <button key={n.key} className={tab === n.key ? 'on' : ''} onClick={() => switchTab(n.key)}>
              <span>{n.icon}
                {n.key === 'estoque' && lowStock > 0 && <span className="nav-dot">{lowStock}</span>}
              </span>
              {n.label}
            </button>
          ))}
        </nav>
      </div>{/* end .main */}

      {/* ══ MODALS ══ */}
      {movModal && (
        <MovimentacaoModal produto={movModal.produto} tipo={movModal.tipo}
          onConfirm={async (payload) => {
            setMovModal(null);
            if (movModal.tipo === 'entrada') await doSave(() => addEntrada(payload.produto_id, payload.quantidade), 'Estoque atualizado!');
            else await doSave(() => addSaida(payload.produto_id, payload.quantidade, payload.cliente_id), 'Venda registrada!');
          }}
          onCancel={() => setMovModal(null)}
        />
      )}

      {editProduto && (
        <div className="ov" onClick={() => setEditProduto(null)}>
          <div className="mo" onClick={(e) => e.stopPropagation()}>
            <div className="mo-handle" />
            <h3>✎ Editar Produto</h3>
            <div className="mo-sub"><strong>{editProduto.nome}</strong> · {editProduto.quantidade} un. em estoque</div>
            <ProdutoForm
              initialData={editProduto}
              onSubmit={async (data) => {
                await doSave(() => updateProduto(editProduto.id, data), 'Produto atualizado!');
                setEditProduto(null);
              }}
              onCancel={() => setEditProduto(null)}
            />
          </div>
        </div>
      )}

<Toast message={toast?.message} type={toast?.type} onClose={() => setToast(null)} />
      <ConfirmModal title={confirm?.title} message={confirm?.message} onConfirm={confirm?.onConfirm} onCancel={confirm?.onCancel} />
    </div>
  );
}
